import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { TreePine, Sparkles } from 'lucide-react';

const START = new Date('2026-11-20T10:00:00-05:00').getTime();
const END = new Date('2026-11-21T18:00:00-05:00').getTime();

const getRemaining = (now) => {
  const diff = Math.max(0, START - now);
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor((diff / 3600000) % 24),
    minutes: Math.floor((diff / 60000) % 60),
    seconds: Math.floor((diff / 1000) % 60),
  };
};

const Unit = ({ value, label }) => (
  <div className="flex flex-col items-center" data-testid={`countdown-${label.toLowerCase()}`}>
    <div className="w-16 sm:w-20 h-16 sm:h-20 rounded-2xl bg-white shadow-sm border border-emerald-100 flex items-center justify-center">
      <span className="font-serif text-3xl sm:text-4xl font-semibold text-emerald-700 tabular-nums">
        {String(value).padStart(2, '0')}
      </span>
    </div>
    <span className="mt-2 text-xs uppercase tracking-[0.2em] text-muted-foreground">{label}</span>
  </div>
);

export const FestivalCountdown = () => {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  if (now >= START) {
    const live = now < END;
    return (
      <div className="mb-8 inline-flex items-center gap-3 rounded-2xl bg-emerald-600 text-white px-6 py-4 shadow-lg" data-testid="festival-countdown-status">
        {live ? <Sparkles className="w-6 h-6" /> : <TreePine className="w-6 h-6" />}
        <span className="font-serif text-xl font-semibold">
          {live ? 'The Trees Are Back! Happening now' : 'See you next year!'}
        </span>
      </div>
    );
  }

  const { days, hours, minutes, seconds } = getRemaining(now);
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.3 }}
      className="mb-8"
      data-testid="festival-countdown"
    >
      <p className="font-accent text-2xl text-emerald-700 mb-3">The Trees are back in...</p>
      <div className="flex items-start gap-3 sm:gap-4">
        <Unit value={days} label="Days" />
        <Unit value={hours} label="Hours" />
        <Unit value={minutes} label="Minutes" />
        <Unit value={seconds} label="Seconds" />
      </div>
    </motion.div>
  );
};
